// Junior Accountant — cloned from the Internal Auditor surface, then additionally
// hiding Attendance, Inbox (never present), Analytics and the Shipping Dashboard.
// Net result: read-heavy
// admin surface across dashboards, orders, finance, exports, reports and resources,
// with no Analytics, no Attendance, no Order Form / Mark Returns (the latter two
// aren't part of the auditor surface either). Router guards in router/index.js are
// the matching source of truth — keep the two in sync.
export const JUNIOR_ACCOUNTANT_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Dashboard', href: '/dashboard', icon: 'cilSpeedometer' },

  { slug: 'title', name: 'Sales' },
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },
  { slug: 'link', name: 'POS Sales', href: '/pos-sales', icon: 'cilReceipt' },

  { slug: 'title', name: 'Finance & Exports' },
  {
    slug: 'dropdown',
    name: 'Payments',
    icon: 'cilDollar',
    elements: [
      { slug: 'link', name: 'COD Payments', href: '/pendingpayments', icon: 'cilHandCoin' },
      { slug: 'link', name: 'Razorpay Transactions', href: '/razorpay-transactions', icon: 'cilCreditCard' },
    ],
  },
  {
    slug: 'dropdown',
    name: 'Exports',
    icon: 'cilShareArrow',
    elements: [
      { slug: 'link', name: 'Tally Export', href: '/tallyexport', icon: 'cilSpreadsheet' },
      { slug: 'link', name: 'Zoho Export', href: '/zohoexport', icon: 'cilFile' },
      { slug: 'link', name: 'Verify Zoho Invoices', href: '/Verifyzohoinvoices', icon: 'cilCheckCircle' },
    ],
  },
  {
    slug: 'dropdown',
    name: 'Reports',
    icon: 'cilReport',
    elements: [
      { slug: 'link', name: 'Sales Report', href: '/salesreport', icon: 'cilChartUp' },
      { slug: 'link', name: 'POS Sales', href: '/pos-sales', icon: 'cilReceipt' },
      { slug: 'link', name: 'Department Report', href: '/departmentreport', icon: 'cilGrid' },
      { slug: 'link', name: 'Branch Report', href: '/branchreport', icon: 'cilChartLine' },
      { slug: 'link', name: 'Agentwise Report', href: '/agentwise_report', icon: 'cilUserChart' },
      { slug: 'link', name: 'Telesales Report', href: '/telesales_report', icon: 'cilPhoneChart' },
      { slug: 'link', name: 'Download Reports', href: '/reports', icon: 'cilCloudDownload' },
    ],
  },
  { slug: 'link', name: 'Refunds', href: '/refund', icon: 'cilMoneyBack' },

  { slug: 'title', name: 'Resources' },
  { slug: 'link', name: 'Info Center', href: '/info-center', icon: 'cilLibrary' },
  { slug: 'link', name: 'Private Notes', href: '/private-notes', icon: 'cilNote' },
]
